import React, { useEffect, useState } from 'react';
import { getReportTypes } from '../api/ReportTypes';
import Select from 'react-select';
import { IReportType } from '../util/DataModelInterface';
import { injectIntl } from 'react-intl';
import { MultiSelectStyles } from '../util/Styles';

interface IReportTypeListProps {
  intl: any;
  multiselect: boolean;
  setType(type: string): any;
  sorter: string;
  selected?: string; // initial value, only for single values
  file?: string;
}

interface IReportTypeOption {
  key: string;
  value: string;
  label: any;
  data?: any;
}

const ReportTypeList: React.FunctionComponent<IReportTypeListProps> = (props: IReportTypeListProps) => {

  const [reportTypes, setReportTypes] = useState([] as IReportType[]);
  const [selected, setSelected] = useState([] as IReportTypeOption[]);
  const [options, setOptions] = useState([] as IReportTypeOption[]);

  useEffect(() => {
    getReportTypes(true).then((data: any) => {
      if (data) {
        setReportTypes(data as IReportType[]);
        props.setType('');
      }
    });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const option = options.find((o) => o.value === props.selected);
    if(option) {
      let newSelected = selected;
      if(props.multiselect) {
        newSelected.push(option);
      } else {
        newSelected = option as any;
      }
      setSelected(newSelected);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.selected]);

  useEffect(() => {
    setSelected([]);
    const newOptions: IReportTypeOption[] = [];
    reportTypes.forEach((type) => {
      if(!props.sorter || !type.sorters || type.sorters.indexOf(props.sorter) > -1) 
        newOptions.push( {key:`${type.sort_report_type_id}`, value: `${type.report_type}`, label: props.intl.formatMessage({id:`report-type.${type.report_type}`}), data: type});
      }
    );
    setOptions(newOptions);
    props.setType('');
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.sorter, reportTypes]);

  return(
    <div  className={props.multiselect ? "" : "col-md-3 typelist"}>
      <Select
        className={"serty-custom-select"}
        styles={MultiSelectStyles}
        options={options}
        isMulti={props.multiselect}
        name="reporttypes"
        placeholder= {props.intl.formatMessage({id:'report-type.choose'})}
        value={selected}
        onChange={(sel: any) => {props.setType(props.multiselect ? sel : sel.value); setSelected(sel);}}
        isSearchable={false}
        closeMenuOnSelect={!props.multiselect}
      />
    </div>);
}

export default injectIntl(ReportTypeList);
